/* Rayon à onglets — bascule d'un panneau à l'autre.
   Les panneaux sont déjà dans la page : le clic ne déclenche aucune requête.
   Navigation clavier conforme au motif ARIA « tabs » (flèches, Origine, Fin). */

(() => {
  const init = (shelf) => {
    const tabs = [...shelf.querySelectorAll('[data-ag-tab]')];
    const panels = [...shelf.querySelectorAll('[data-ag-panel]')];
    const cta = shelf.querySelector('[data-ag-cta]');
    if (tabs.length < 2) return;

    const select = (index, { focus = false } = {}) => {
      tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (panels[i]) panels[i].hidden = !selected;
      });

      const active = tabs[index];
      if (cta && active.dataset.ctaUrl) {
        cta.href = active.dataset.ctaUrl;
        if (active.dataset.ctaLabel) cta.textContent = active.dataset.ctaLabel;
      }

      // Le panneau change de contenu : on ramène le défilement horizontal au
      // début, sinon la grille mobile s'ouvre au milieu de la liste précédente.
      const grid = panels[index]?.querySelector('.ag-cards');
      if (grid) grid.scrollLeft = 0;

      if (focus) active.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', (event) => {
        const last = tabs.length - 1;
        let next = null;

        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;

        if (next === null) return;
        event.preventDefault();
        select(next, { focus: true });
      });
    });
  };

  const boot = () => document.querySelectorAll('.ag-shelf').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Le thème réinjecte les sections dans l'éditeur : on ré-initialise.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.ag-shelf').forEach(init);
  });
})();
